import React from 'react';
import { useMEMTranslation } from '../../utils/text-utils';
import { Text, Button } from '../../providers/harmony-scope/lazy-enablers';
import { FED_FAQ_LINK, FED_RBI_GUIDE_LINK, FED_SUPPORT_EMAIL, FED_UBI_GUIDE_LINK } from '../../constants/links';
import { useIsFed } from '../../utils/utils-fed';

export const HelpAndSupportPanelContent = () => {
  const { t } = useMEMTranslation();
  const isFedVal = useIsFed();

  return (
    <>
      <Text slot="heading">{t('navHeaderHelpAndSupport')}</Text>
      <br />
      <div style={{ display: 'flex', flexWrap: 'wrap' }}>
        <Text appearance="paragraph">{`${t('panelSupportLearnLeadIn')}`}</Text>
        &nbsp;
        <Button href={FED_RBI_GUIDE_LINK} appearance="link" target="_blank" external>
          {t('panelSupportRBILink')}
        </Button>
        &nbsp;
        <Text appearance="paragraph">{`${t('panelSupportOr')} `}</Text>
        &nbsp;
        <Button href={FED_UBI_GUIDE_LINK} appearance="link" target="_blank" external>
          {t('panelSupportUBILink')}
        </Button>
      </div>
      <br />
      <br />
      <div style={{ display: 'flex', flexWrap: 'wrap' }}>
        <Text appearance="paragraph">{`${t('panelSupportExploreLeadIn')} `}</Text>
        &nbsp;
        <Button href={FED_FAQ_LINK} appearance="link" target="_blank" external>
          {t('panelSupportFAQLink')}
        </Button>
      </div>
      <br />
      <br />
      <div style={{ display: 'flex', flexWrap: 'wrap' }}>
        <Text appearance="paragraph">{`${t('panelSupportContact')} `}</Text>
        &nbsp;
        <Button href={FED_SUPPORT_EMAIL} appearance="link" target="_blank" external>
          {t('panelSupportContactLink')}
        </Button>
      </div>
      <br />
      <br />
      {isFedVal && <Text appearance="metadata">{`${t('panelSupportCorpNet')}`}</Text>}
    </>
  );
};
